// File: /src/components/dashboard/SummaryCards.js

import React from 'react';
import { Link } from 'react-router-dom';
import { FaUsers } from 'react-icons/fa';

const SummaryCards = ({ clientsCount, projectsCount, invoicesCount }) => (
	<div className="card">
		<div className="card-icon">
			<FaUsers size={16} />
		</div>
		<h2>Clientes</h2>
		<Link to="/grid-clients">
			<button>Gerenciar Clientes</button>
		</Link>
		<p>Total de Clientes: {clientsCount}</p>
		<p>Total de Projetos: {projectsCount}</p>
		<p>Total de Faturas: {invoicesCount}</p>
	</div>
);

export default SummaryCards;
